import _ from "lodash";
import DebugLogger from "../../../../utils/DebugLogger";
import DynamicServiceHelper from "./DynamicServiceHelper";

const TAG = "RNSpeechRecognize AlI2";
const Host = "nls-gateway-ap-southeast-1.aliyuncs.com";

export default class AliYunIntIATSpeechRecognitionService {
    TIMEOUT_SECONDS = 180;

    appKey = "";
    apiKeyId = "";
    apiKeySecret = "";
    punc = false;
    nunum = false;
    useProxy = false;
    proxyAddress = "";

    //for now it is generate by java code, if we use this, we should generate token in the server side.
    token = null;
    expireTime = 0;

    streamSendingError = false;
    realTimeVoiceDataWriter = null;

    tmpReferenceText = null;
    tmpCallback = null;
    isRecording = false; // we will not throw exception/reject promise when recording for stream request

    constructor(configMap) {
        this.appKey = configMap.appKey;
        this.token = configMap.token;
        this.expireTime = configMap.expireTime;
        if (_.has(configMap, "punc")) {
            //标点过滤控制，默认返回标点，punc=0会过滤结果中的标点
            this.punc = _.isEqual(configMap.punc, "1");
        }
        if (_.has(configMap, "nunum")) {
            //将返回结果的数字格式规则为阿拉伯数字格式, 默认关闭
            this.nunum = _.isEqual(configMap.nunum, "1");
        }
        if (_.has(configMap, "useProxy")) {
            this.useProxy = configMap.useProxy;
        }
        if (_.has(configMap, "proxyAddress")) {
            this.proxyAddress = configMap.proxyAddress;
        }
        //NOTE:: we only can use proxy server for aliyun
        this.useProxy = true;
        this.proxyAddress = _.isEmpty(configMap.proxyAddress) ? "proxy.yidu.ink" : configMap.proxyAddress;
    }

    Recognize(referenceText, wav, callback) {
        //start request.

        DebugLogger.log(TAG, "ajax call start");
        const requestUrl = this.GenerateUrl(this.appKey, this.punc, this.nunum);

        const mediaType = "application/octet-stream";

        //initializeToken();
        const finalUrl = DynamicServiceHelper.GetUrl(requestUrl, 5, this.useProxy, this.proxyAddress);

        wav.arrayBuffer()
            .then(audioContent => {
                fetch(finalUrl, {
                    method: "POST",
                    processData: false,
                    contentType: false,
                    headers: {
                        "X-NLS-Token": this.token,
                        "Content-type": "application/octet-stream",
                        Host: Host,
                        "Content-Length": audioContent.length,
                        SendChunked: "true",
                    },
                    body: audioContent,
                })
                    .then(response => response.json())
                    .then(responseData => {
                        if (_.has(responseData, "result") && responseData.status === 20000000) {
                            callback.onSuccess("", responseData.result);
                        } else {
                            callback.onFailure("Request Failed", responseData.message);
                        }
                    })
                    .catch(err => {
                        DebugLogger.log("_postFileApi err", err);
                        callback.onFailure("Error", err.message);
                    });

                DebugLogger.log(TAG, "ajax call build end");
            })
            .catch(err => {
                DebugLogger.log("_postFileApi err", err);
                callback.onFailure("Error", err.message);
            });
    }

    BeforeSendVoiceData(referenceText, callback) {
        throw new Error("recognize with record is not supported");
        //start request.
        //we are recording now isRecording(after some ms)
        // this.isRecording = true;
        //
        // this.tmpReferenceText = referenceText;
        // this.streamSendingError = false;
        // this.tmpCallback = callback;
        // DebugLogger.log(TAG, "ajax call start");
        // const requestUrl = this.GenerateUrl(this.appKey, this.punc, this.nunum);
        //
        // const mediaType = "application/octet-stream";
        //
        // //initializeToken();
        // const finalUrl = DynamicServiceHelper.GetUrl(requestUrl, 5, this.useProxy, this.proxyAddress);

        // wav.blob()
        //     .then(audioContent => {
        //         fetch(finalUrl, {
        //             method: "POST",
        //             processData: false,
        //             contentType: false,
        //             headers: {
        //                 "X-NLS-Token": this.token,
        //                 "Content-type": "application/octet-stream",
        //                 Host: Host,
        //                 "Content-Length": audioContent.length,
        //                 SendChunked: "true",
        //             },
        //             body: audioContent,
        //         })
        //             .then(response => response.json())
        //             .then(responseData => {
        //                 if (responseData.result && responseData.status === 20000000) {
        //                     callback.onSuccess("", responseData.result);
        //                 } else {
        //                     callback.onFailure("Request Failed", responseData.message);
        //                 }
        //             })
        //             .catch(err => {
        //                 DebugLogger.log("_postFileApi err", err);
        //                 callback.onFailure("Error", err.message);
        //             });
        //
        //         DebugLogger.log(TAG, "ajax call build end");
        //     })
        //     .catch(err => {
        //         DebugLogger.log("_postFileApi err", err);
        //         callback.onFailure("Error", err.message);
        //     });
    }

    SendVoiceData(voiceData, offset, length) {
        //if error in stream request, we just do not send anymore
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            try {
                this.realTimeVoiceDataWriter.write(voiceData, offset, length);
            } catch (ex) {
                this.streamSendingError = true;
                DebugLogger.log(TAG, "SendVoiceData Error:");
                DebugLogger.log(TAG, ex.message);
            }
        }
    }

    AfterSendVoiceData(wav) {
        this.isRecording = false;
        DebugLogger.log(TAG, "AfterSendVoiceData");
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            DebugLogger.log(TAG, "AfterSendVoiceData Normal Case");
            this.realTimeVoiceDataWriter.stop();
            this.realTimeVoiceDataWriter = null;
        } else {
            DebugLogger.log(TAG, "AfterSendVoiceData Bad Case");
            this.Recognize(this.tmpReferenceText, wav, this.tmpCallback);
        }
    }

    IsErrorWhenSendingStream() {
        return this.streamSendingError;
    }

    NeedSendWavHeaderInNetworkStream() {
        return true;
    }

    destroy() {
        //nothing to do
    }

    GenerateUrl(appKey, punc, nunum) {
        /**
         * 设置HTTP RESTful POST请求：
         * 1.使用HTTP协议。
         * 2.语音识别服务域名：nls-gateway.cn-shanghai.aliyuncs.com。
         * 3.语音识别接口请求路径：/stream/v1/asr。
         * 4.设置必选请求参数：appkey、format、sample_rate。
         * 5.设置可选请求参数：enable_punctuation_prediction、enable_inverse_text_normalization、enable_voice_detection。
         */
        let request = `https://${Host}/stream/v1/asr`;
        request = request + "?appkey=" + appKey;
        request = request + "&format=pcm";
        request = request + "&sample_rate=16000";
        if (!punc) {
            request = `${request}&enable_punctuation_prediction=true`;
        }
        if (nunum) {
            request = `${request}&enable_inverse_text_normalization=true`;
        }
        /*if (enableVoiceDetection) {
            request = request + "&enable_voice_detection=" + true;
        }*/
        // NOTE: 不开启enable_voice_detection，录音时不说话会返回错误的结果(阿里云对背景噪音进行了识别?)
        request = request + "&enable_voice_detection=" + "true";
        request = request + "&max_start_silence=60000";
        request = request + "&max_end_silence=60000";
        return request;
    }
}
